const phones = {
  MEMBER: '(31) 98222-5779',
  NOT_MEMBER: '(31) 99154-2158',
};

const paymentEnum = {
  PROCESSING: 'processing',
  AUTHORIZED: 'authorized',
  PAID: 'paid',
  REFUNDED: 'refunded',
  WAITING_PAYMENT: 'waiting_payment',
  PENDING_REFUND: 'pending_refund',
  REFUSED: 'refused',
  YEAR_SUBSCRIPTION: 'yearly',
  YEAR_PERIOD: 365,
  MONTH_SUBSCRIPTION: 'monthly',
  MONTH_PERIOD: 30,
  BILLET_PAYMENT: 'boleto',
  CREDIT_CARD_PAYMENT: 'credit_card',
  DEFAULT_CURRENCY: 'BRL',
  DEFAULT_CATEGORY: 'Queima Diária',
};

const liveStatusEnum = {
  LIVE: 'live',
  CLOSED: 'closed',
  UNPUBLISHED: 'unpublished',
  DELETED: 'deleted',
};

const liveStatusTranslated = {
  live: 'AO VIVO',
  closed: 'FINALIZADA',
  unpublished: 'EM BREVE',
  deleted: 'EXCLUÍDA',
};

const viewTypeEnum = {
  DESKTOP: 'tv',
  TABLET: 'tablet',
  MOBILE: 'mobile',
};
const animationEnum = {
  IN: 'in',
  OUT: 'out',
};

const itemDropdownStatus = {
  ACTIVE: 'active',
  DEACTIVATE: 'deactivate',
  DANGER: 'danger',
};

const modalTypeEnum = {
  DELETE: 'delete',
  UPDATE: 'update',
};

const userTypes = [
  {
    id: 1,
    name: 'Premium',
  },
  {
    id: 2,
    name: 'Fremium',
  },
  {
    id: 3,
    name: 'Todos',
  },
];
const bannerType = {
  PROGRAM: 'programa',
  CAMPAIGN: 'campanha',
};

const testUserAgent = reg => reg.test('');

const isDevice = testUserAgent(
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i
);

const isDesktop = !isDevice;

const isSafariOrFireFox = testUserAgent(/Safari|Firefox/i);

export {
  phones,
  paymentEnum,
  isDesktop,
  isDevice,
  isSafariOrFireFox,
  liveStatusEnum,
  viewTypeEnum,
  animationEnum,
  liveStatusTranslated,
  itemDropdownStatus,
  modalTypeEnum,
  userTypes,
  bannerType,
};
